<template>
    <div class="ut-setting">
      <div class="step">
        <div class="ut-header">
          <h2 v-html="$t('userTest.selecting.title')"></h2>
          <span>({{timezone || applyData.timezone}}) {{applyData.timezoneName}}</span>
        </div>
        <div class="ut-body">
          <ul v-if="utList">
            <li v-for="(ut, i) in utList"
                :key="`ut-${i}`">
              <ui-radio v-model="utid"
                        :radioLabel="'radio' + i"
                        :radioName="'ut'"
                        :inputValue="ut.utid">
                <span class="date">
                  {{ dateString(ut.startDate) }}
                </span>
                <span class="name">
                  {{ ut.testName }}
                </span>
              </ui-radio>
            </li>
          </ul>
          <div v-else
               class="empty">
            <i class="icon icon--empty"></i><br>
            {{ $t('common.noCollectedData') }}
          </div>
        </div>
        <div class="ut-footer">
          <ui-button @click="cancelSelected">{{ $t('common.cancel') }}</ui-button>
          <ui-button @click="applySelected"
                     :primary2="true">{{ $t('common.apply') }}</ui-button>
        </div>
      </div>
    </div>

</template>

<script>
import { parse, format } from 'date-fns'

import UiButton from '@/components/ui/UiButton'
import UiRadio from '@/components/ui/UiRadio'
import { mapState } from 'vuex'
import { dateFormatTimezone, getOffset } from '@/libs/utils'

export default {
  name: 'UserTest',
  components: {
    UiButton,
    UiRadio
  },
  props: ['utList'],
  methods: {
    applySelected () {
      this.$emit('onClose', this.utid)
    },
    cancelSelected () {
      this.$emit('onClose', null)
    },
    dateString (date) {
      return dateFormatTimezone(parse(date), this.applyData.timezoneName, 'YYYY.MM.DD')
    }
  },
  created () {

  },
  computed: {
    ...mapState([
      'applyData'
    ]),
    timezone () {
      return getOffset(this.applyData.timezoneName)
    }
  },
  data () {
    return {
      utid: null
    }
  }
}
</script>

<style lang="scss" scoped>
.ut-setting {
  width: 600px;
  height: 367px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;

  .step {
    position: relative;
    background-color: #ffffff;
    border-radius: 15px;
    width: 100%;
    height: 100%;

    .ut-header {
      position: relative;
      padding: 30px 30px 0;

      h2 {
        font-size: 15px;
        color: #2f2f2f;

        & /deep/ span {
          color: #ec0047;
        }
      }

      span {
        position: absolute;
        bottom:0;
        right: 30px;
        color: #666;
        font-size: 12px;
      }
    }

    .ut-body {
      height: 238px;
      margin: 14px 30px 16px;
      border-radius: 5px;
      border: solid 1px #d7d7d7;
      background-color: #f4f4f4;
      overflow: auto;

      ul {
        padding: 10px 0;

        li {
          margin: 0 7px 1px;

          &:hover {
            border-radius: 5px;
            background-color: #e0e0e0;
          }

          & /deep/ .input-wrap {
            margin-top: 0;
            padding-left: 0;

            label {
              font-size: 13px;
              line-height: 1.31;
              color: #666;
              display: block;
              padding: 8px 10px 10px 40px;
              background-position: left 10px top 9px;

              .date {
                padding-top: 1px;
                display: inline-block;
                vertical-align: top;
                width: 85px;
              }

              .name {
                padding-top: 1px;
                display: inline-block;
                vertical-align: top;
                width: 390px;
                word-break: break-all;
                white-space: normal;
              }
            }
          }
        }
      }

      .empty {
        width: 100%;
        height: 312px;
        border-radius: 5px;
        border: 1px solid #d7d7d7;
        background-color: #f4f4f4;
        line-height: 1.77;
        color: #666666;
        font-size: 14px;
        text-align: center;
        margin-bottom: 3px;

        i {
          margin-top: 104px;
        }
      }
    }

    .ut-footer {
      margin: 14px 15px;
      text-align: center;
      position: relative;

      .ui-btn {
        margin: 0 2px 0 3px;
        width: 95px;

        &.back {
          position: absolute;
          top: 0;
          left: 0;
          border: none;
          font-size: 13px;
          width: 75px;
          text-align: center;
        }
      }
    }
  }
}
</style>
